import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const UserStore = require('./user').default
const MqttStore = require('./mqtt').default
export { UserStore, MqttStore }